import styled from 'styled-components'

export const TagRemoveButtonStyled = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0;
  margin-left: ${(props) => props.theme.typography.pxToRem(4)};
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
`
